<template>
    <el-dialog v-if="pageType === 'dialog'" v-model="dialogFormVisible" class="form-dialog" :title="title" width="60%">
        <template v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
            <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
        </template>
        <slot name="content_top">
            <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_top'" v-html="pageInfo.extra_html.html"></div>
        </slot>
        <el-form
            :model="formobj"
            :label-position="pageInfo && pageInfo.form_config.label_position ? pageInfo.form_config.label_position : 'top'"
            :label-width="pageInfo && pageInfo.form_config.label_width ? pageInfo.form_config.label_width : ''"
            :size="pageInfo && pageInfo.form_config.size ? pageInfo.form_config.size : ''"
            :disabled="pageInfo && pageInfo.form_config.disabled ? true : false"
            class="form-box">
            <slot name="form_top">
                <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_top'" v-html="pageInfo.extra_html.html"></div>
            </slot>
            <forms :formobj="formobj"></forms>
            <slot name="form_bottom">
                <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_bottom'" v-html="pageInfo.extra_html.html"></div>
            </slot>
        </el-form>
        <slot name="form_bottom">
            <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_bottom'" v-html="pageInfo.extra_html.html"></div>
        </slot>
        <template #footer>
            <span class="dialog-footer">
                <el-button :size="submitBntConfig.size" @click="dialogFormVisible = false">关闭</el-button>
                <el-button
                    :type="submitBntConfig.type"
                    :size="submitBntConfig.size"
                    :color="submitBntConfig.color"
                    :disabled="submitBntConfig.disabled"
                    @click="onSubmit">
                    {{ submitBntConfig.title }}
                </el-button>
            </span>
        </template>
    </el-dialog>

    <template v-else-if="pageType === 'tab'">
        <el-container v-if="pageInfo">
            <el-main>
                <el-card shadow="never">
                    <template v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
                        <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
                    </template>
                    <slot name="content_top">
                        <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_top'" v-html="pageInfo.extra_html.html"></div>
                    </slot>
                    <el-tabs v-model="pageCurrTab" tab-position="top" @tab-change="tabChange">
                        <el-tab-pane v-for="(tab, index) in pageInfo.tab_nav.tab_list" :key="index" :label="tab" :name="index">
                            <el-form
                                :model="formobj"
                                :label-position="pageInfo && pageInfo.form_config.label_position ? pageInfo.form_config.label_position : 'top'"
                                :label-width="pageInfo && pageInfo.form_config.label_width ? pageInfo.form_config.label_width : ''"
                                :size="pageInfo && pageInfo.form_config.size ? pageInfo.form_config.size : ''"
                                :disabled="pageInfo && pageInfo.form_config.disabled ? true : false"
                                class="form-box">
                                <slot name="form_top">
                                    <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_top'" v-html="pageInfo.extra_html.html"></div>
                                </slot>
                                <forms :formobj="formobj"></forms>
                                <el-form-item>
                                    <el-button
                                        :type="submitBntConfig.type"
                                        :size="submitBntConfig.size"
                                        :color="submitBntConfig.color"
                                        :disabled="submitBntConfig.disabled"
                                        @click="onSubmit">
                                        {{ submitBntConfig.title }}
                                    </el-button>
                                </el-form-item>
                                <slot name="form_bottom">
                                    <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_bottom'" v-html="pageInfo.extra_html.html"></div>
                                </slot>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                    <slot name="content_bottom">
                        <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_bottom'" v-html="pageInfo.extra_html.html"></div>
                    </slot>
                </el-card>
            </el-main>
        </el-container>
    </template>

    <template v-else>
        <el-container v-if="pageInfo">
            <el-main>
                <template v-if="pageInfo && pageInfo.page_tips && pageInfo.page_tips.title">
                    <pagetips class="pagetips-box" :tip="pageInfo.page_tips"></pagetips>
                </template>
                <slot name="content_top">
                    <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_top'" v-html="pageInfo.extra_html.html"></div>
                </slot>
                <el-card class="box-card">
                    <template #header>
                        <div class="card-header">
                            <span> {{ title }} </span>
                        </div>
                    </template>
                    <div>
                        <el-form
                            :model="formobj"
                            :label-position="pageInfo && pageInfo.form_config.label_position ? pageInfo.form_config.label_position : 'top'"
                            :label-width="pageInfo && pageInfo.form_config.label_width ? pageInfo.form_config.label_width : ''"
                            :size="pageInfo && pageInfo.form_config.size ? pageInfo.form_config.size : ''"
                            :disabled="pageInfo && pageInfo.form_config.disabled ? true : false"
                            class="form-box">
                            <slot name="form_top">
                                <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_top'" v-html="pageInfo.extra_html.html"></div>
                            </slot>
                            <forms :formobj="formobj"></forms>
                            <el-form-item>
                                <el-button
                                    :type="submitBntConfig.type"
                                    :size="submitBntConfig.size"
                                    :color="submitBntConfig.color"
                                    :disabled="submitBntConfig.disabled"
                                    @click="onSubmit">
                                    {{ submitBntConfig.title }}
                                </el-button>
                            </el-form-item>
                            <slot name="form_bottom">
                                <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'form_bottom'" v-html="pageInfo.extra_html.html"></div>
                            </slot>
                        </el-form>
                    </div>
                </el-card>
                <slot name="content_bottom">
                    <div v-if="pageInfo && pageInfo.extra_html && pageInfo.extra_html.tag === 'content_bottom'" v-html="pageInfo.extra_html.html"></div>
                </slot>
            </el-main>
        </el-container>
    </template>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, reactive, toRaw, watch } from 'vue'
    import Forms from './form'
    import Pagetips from './pagetips'
    export default defineComponent({
        components: {
            Forms,
            Pagetips
        },
        props: {
            pageInfo: {
                type: Object || Array,
                default: () => { }
            },
            pageType: {
                type: String,
                default: 'card'
            },
            title: {
                type: String,
                default: ''
            },
            forms: {
                type: Object || Array,
                default: ''
            }
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()
            const formobj = ref(props.forms)
            const dialogFormVisible = inject('dialogFormVisible')
            const pageCurrTab = ref()
            if (props.pageType === 'tab') {
                pageCurrTab.value = props.pageInfo.tab_nav.curr_tab
            }
            const onSubmit = () => {
                if (props.pageInfo.submit_confirm) {
                    proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                        if (e) {
                            context.emit('update:onSubmit', proxy.jiu.getFormData(formobj))
                        }
                    }, 'warning')
                } else {
                    context.emit('update:onSubmit', proxy.jiu.getFormData(formobj))
                }
            }
            const tabChange = (e) => {
                context.emit('update:onTabChange', e)
            }
            const submitBntConfig = ref({ title: '提交', type: 'primary' })
            if (props.pageInfo && props.pageInfo.btn_config.submit) {
                submitBntConfig.value = props.pageInfo.btn_config.submit
            }
            const setRiggers = () => {
                if (props.pageInfo && props.pageInfo.field_triggers) {
                    for (let rigger_index in props.pageInfo.field_triggers) {
                        let triggers = props.pageInfo.field_triggers[rigger_index]
                        for (let ri in triggers) {
                            let data = ''
                            formobj.value.forEach((item, index) => {
                                if (item.type === 'group') {
                                    for (let i in item.options) {
                                        for (let ii in item.options[i]) {
                                            if (item.options[i][ii].name === rigger_index) {
                                                data = item.options[i][ii].value
                                            }
                                        }
                                    }
                                } else {
                                    if (item.name === rigger_index) {
                                        data = item.value
                                    }
                                }
                            })
                            if (typeof data === 'number') {
                                data = data.toString()
                            }
                            let vals = triggers[ri].values.split(',')
                            let fields = triggers[ri].field.split(',')
                            fields.forEach((fit, fin) => {
                                formobj.value.forEach((item, index) => {
                                    if (item.type === 'group') {
                                        for (let i in item.options) {
                                            for (let ii in item.options[i]) {
                                                if (item.options[i][ii].name === fit) {
                                                    if (vals.includes(data)) {
                                                        item.options[i][ii].is_show = true
                                                    } else {
                                                        if (triggers[ri].is_clear) {
                                                            item.options[i][ii].value = ''
                                                        }
                                                        item.options[i][ii].is_show = false
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        if (item.name === fit) {
                                            if (vals.includes(data)) {
                                                item.is_show = true
                                            } else {
                                                if (triggers[ri].is_clear) {
                                                    item.value = ''
                                                }
                                                item.is_show = false
                                            }
                                        }
                                    }
                                })
                            })
                        }
                    }
                }
            }

            watch(
                () => formobj,
                (newv, oldv) => {
                    setRiggers()
                    context.emit('update:modelValue', formobj)
                },
                { deep: true }
            )
            watch(
                () => props.forms,
                (newv, oldv) => {
                    formobj.value = props.forms
                },
                { deep: true }
            )
            setRiggers()

            return {
                pageCurrTab,
                dialogFormVisible,
                submitBntConfig,
                formobj,
                tabChange,
                onSubmit
            }
        }
    })
</script>
<style>
    .form-tabs{ margin-bottom: 15px;}
</style>
